import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

interface LogoProps extends Omit<ComponentProps<"img">, "src" | "alt" | "width" | "height" | "className"> {
  readonly className?: string;

}

export function Logo({ className, ...props }: LogoProps) {
  return (
    <span 
      className={cn("relative inline-block", className)}
      style={{ backgroundColor: "transparent", display: "inline-block" }}
    >
      <img
        src="/assets/logo.png"
        alt="ezRecipeBox Logo"
        width={64}
        height={64}
        className="object-contain w-full h-full"
        style={{ 
          backgroundColor: "transparent",
          mixBlendMode: "normal"
        }}
        {...props}
      />
    </span>
  );
}
